import Translator from "../../utils/translator";
import { createElement, empty } from "../../utils/vanilla";
import { CancelablePromise as Promise } from "../../utils/cancelablePromise";
import { convertDecimalToTimeString } from "hos-tools";
import ProgressCircle from "../framework/progressCircle";

const HOURS = 1000 * 60 * 60;

interface ILockProgressBarOptions {
    iconClass?: string;
    title: string;
    container: HTMLElement;
    translator: Translator;
    className: string;
    max: number;
    min: number;
    translatedUnits?: string[];
    noTranslate?: boolean;
}

export default class LockProgressBar {
    private readonly iconClass: string;
    private readonly title: string;
    private readonly container: HTMLElement;
    private readonly translator: Translator;
    private readonly className: string;
    private readonly finish: number;
    private readonly start: number;
    private readonly noTranslate: boolean;
    private readonly translatedUnits: string[];

    constructor (options: ILockProgressBarOptions) {
        this.iconClass = options.iconClass || "";
        this.title = options.title;
        this.container = options.container;
        this.translator = options.translator;
        this.className = options.className || "";
        this.finish = options.max;
        this.start = options.min;
        this.translatedUnits = options.translatedUnits || [];
        this.noTranslate = options.noTranslate || false;
    }

    render(): Promise<void> {
        return this.assembleBlock()
            .then(progressBar => {
                if (this.start > this.finish) {
                    throw new Error(`Current timespan can not be higher than finish timespan (start: ${ this.start }, finish: ${ this.finish }, title: ${ this.title }).`);
                }

                this.className && progressBar.classList.add(this.className);
                empty(this.container);
                this.container.appendChild(progressBar);
                this.adjustSpacing();
            });
    }

    remove() {
        empty(this.container);
    }

    private assembleBlock (): Promise<HTMLDivElement> {
        return (this.noTranslate ? Promise.resolve(this.title) : this.translator.translate(this.title))
            .then(translatedTitle => {
                let wrapper = createElement("div", "lock-bar__wrapper");

                let circleContainer = createElement("div", "lock-bar__progress-circle");
                let svgCircle = new ProgressCircle().createSvgCircle({
                    progressClass: this.className,
                    progress: this.start / this.finish,
                    icon: this.iconClass
                });
                circleContainer.innerHTML = svgCircle;
                wrapper.appendChild(circleContainer);

                let headerWrapper = createElement("div", "lock-bar__header-wrapper");

                let titleElement = createElement("span", "lock-bar__title");
                titleElement.innerHTML = `${ translatedTitle }`;
                headerWrapper.appendChild(titleElement);
                let durationElem = createElement("span", "lock-bar__duration");
                durationElem.innerText = convertDecimalToTimeString(this.start / HOURS).replace("{0}", this.translatedUnits[0]).replace("{1}", this.translatedUnits[1]);
                headerWrapper.appendChild(durationElem);

                wrapper.appendChild(headerWrapper);

                return wrapper;
            });
    }

    private adjustSpacing() {
        let allLockBars = document.querySelectorAll(".lock-bar__wrapper");
        if (allLockBars && allLockBars.length > 4) {
            let lockBarContainer = document.querySelector(".lock-bars-container");
            lockBarContainer && (lockBarContainer.classList.add("multi-line"));
        }
    }
}